import { DevicesLicensesResponseDTOV1 } from '../swagger-api-v1';

export class DeviceLicenses {
  constructor(
    public mobileCapacity: number,
    public mobileAvailable: number,
    public windowsCapacity: number,
    public windowsAvailable: number,
    public childCapacity: number,
    public childAvailable: number,
    public onnetCapacity: number,
    public onnetAvailable: number,
    public desktopCapacity: number,
    public desktopAvailable: number
  ) {}

  public static fromDTO(dto: DevicesLicensesResponseDTOV1): DeviceLicenses {
    return new DeviceLicenses(
      dto.mobile.capacity,
      dto.mobile.available,
      dto.windows.capacity,
      dto.windows.available,
      dto.mobileChildProtection.capacity,
      dto.mobileChildProtection.available,
      dto.onnet.capacity,
      dto.onnet.available,
      dto.desktop.capacity,
      dto.desktop.available
    );
  }

  public get totalAvailable(): number {
    return (
      this.mobileAvailable +
      this.windowsAvailable +
      this.childAvailable +
      this.onnetAvailable +
      this.desktopAvailable
    );
  }
}
